import { render } from "./SectionL.vue?vue&type=template&id=d834abb8"
import script from "./SectionL.vue?vue&type=script&lang=js"
export * from "./SectionL.vue?vue&type=script&lang=js"

import "./SectionL.vue?vue&type=style&index=0&id=d834abb8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__